import {
  dateFilter, defaultOrgTypesDataReceiver, encashmentsStatusFilter, orgTypesFilter, orgTypesFilterSelection, orgsFilter, orgsFilterSelection,
} from 'app/dataProviders/filter-items'
import { encashmentsStatusFilterSelection, getEncashmentsStatusData } from 'app/dataProviders/filter-items/encashmentsStatusFilter'


export const filterInit = () => {
  orgTypesFilter.addDataReceiver(
    defaultOrgTypesDataReceiver,
  )
  orgTypesFilter.dataReceive()
  orgTypesFilter.setStatusReady()

  encashmentsStatusFilter.updateData(
    getEncashmentsStatusData,
  )
  encashmentsStatusFilter.setStatusReady()

  return () => {
    orgTypesFilterSelection.reset()
    orgsFilterSelection.reset()
    encashmentsStatusFilterSelection.reset()

    orgTypesFilter.reset()
    dateFilter.reset()
    orgsFilter.reset()
    encashmentsStatusFilter.reset()
  }
}

export const resetToDefaultAll = () => {
  orgTypesFilterSelection.resetToDefault()
  orgsFilterSelection.resetToDefault()
  dateFilter.resetToDefault()
  encashmentsStatusFilterSelection.resetToDefault()
}
